import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { splitPrize } from '../../../utils';
import styles from '../shared.scss';

import { TXTCLI_Top_Prize_1 } from './TopPrize.messages.json';

export interface TopPrizeProps {
  scriptId: number;
  prize?: string;
  isCustomPrize?: boolean;
  isUltra?: boolean;
}

const TopPrizeValue: React.FC<Omit<TopPrizeProps, 'scriptId'>> = ({
  prize,
  isUltra,
  isCustomPrize
}) => {
  const [firstLine, secondLine] = splitPrize(prize);

  return (
    <div
      className={classNames(styles.value, styles.footerValue, {
        [styles.customPrize]: isCustomPrize && prize?.length && prize?.length > 10
      })}
    >
      {!secondLine || !isCustomPrize || isUltra ? (
        <div>{prize}</div>
      ) : (
        <div className={styles.customPrize}>
          <div>{firstLine}</div>
          <div>{secondLine}</div>
        </div>
      )}
    </div>
  );
};

const TopPrize: React.FC<TopPrizeProps> = ({ scriptId, prize, isCustomPrize, isUltra }) => (
  <footer className={styles.footerWrapper} key={scriptId}>
    <div className={styles.footerLabel}>
      <Translation {...TXTCLI_Top_Prize_1} />
    </div>

    <TopPrizeValue prize={prize} isCustomPrize={isCustomPrize} isUltra={isUltra} />
  </footer>
);

export default TopPrize;
